module.exports = __webpack_public_path__ + "img/icon_xmtj.0b5018bc.png";